export default __webpack_public_path__ + "i18n/translations/translation-da.a8bba19d.json";